
<div class="branding-page-wrapper">
  <org-header></org-header>

  <div class="branding-wrapper">
    <div class="branding-container">
      <div class="branding-backdrop-image">
        <div class="backdrop-image-group">
          <img
            src="../../../../../static/img/enterprise/branding-demo-image.jpg"
            class="branding-demo-image"
            alt="brandingImage"
          />
        </div>
        <div class="demo-example-container">
          <div class="demo-example-box">
            <div class="demo-example-head">
              <span class="demo-example-logo">
                <img :src="demoImageSrc" alt="logo" />
              </span>
              <p class="demo-example-caption">{{brandName}}</p>
            </div>
            <div class="demo-side-panel-container">
              <div class="demo-side-panel"></div>
              <div class="demo-side-editor">
                <div class="demo-editor-area">
                  <div class="demo-editor-area-head"></div>
                  <div class="demo-editor-area-body">
                    <div
                      :style="`background-color: ${brandAccentColor}`"
                      class="editor-area-side"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="setup-brand-container">
        <div class="setup-location-container">
          <cvt-floating-breadcrumb
            :mode="'LIGHT'"
            :active-menu="activeMenu"
            :menus="breadcrumbMenus"
            :hide-back-btn="true"
            :hide-next-btn="true"
            @menuChanged="(eventData) => onBreadCrumbSelectionChange(eventData)"
          />
        </div>
        <div>
          <h3>Set up your brand</h3>
          <p class="branding-caption">
            Based on what you told us, we found the following styles for
            {{brand.name || '[Company Name]'}}. Want to make changes? Update
            your styles below. Click "Next" to proceed.
          </p>
        </div>

        <!-- Primary Logo -->
        <div class="primary-logo-container">
          <p>Primary Logo</p>
          <div class="primary-logo-group">
            <div
              v-for="(logo, idx) in brand.logos"
              :key="idx"
              class="primary-logo-box-container"
              @click="onSelectLogo(logo, idx)"
            >
              <div
                class="primary-logo-box"
                :class="{ 'active': activeLogo === idx }"
              >
                <img :src="logo.formats[0].src" alt="brandingImage" />
                <div class="active-check">
                  <img
                    v-show="activeLogo === idx"
                    src="../../../../../static/img/enterprise/branding-check-light.svg"
                    class="active-check-logo"
                    alt="check"
                  />
                </div>
              </div>
            </div>
            <div class="branding-add-new-container" @click="onShowUploadModal">
              <img
                src="../../../../../static/img/enterprise/branding-add-new-icon.svg"
                class="branding-add-new-icon"
                alt="add-new-icon"
              />
            </div>
            <cvt-dialog
              bg-color="#ffffff"
              :show="showUploadModal"
              size="sm"
              :height-auto="true"
              :show-close="true"
              @close="onShowUploadModal"
            >
              <alt-upload-dropzone
                ref="uploadDropzone"
                :image-only="true"
                :size-limit="5"
                :hide-gallery-button="true"
                @complete="onCompleteUpload"
              />
            </cvt-dialog>
          </div>
        </div>

        <!-- Color Section -->
        <div class="primary-color-container">
          <p>Primary Color</p>
          <div class="primary-color-group">
            <div
              v-for="(color, idx) in brandColors"
              :key="idx"
              class="primary-color-box-container"
              @click="onSelectColor(idx)"
            >
              <div
                :style="`background-color: ${color.hex};`"
                class="primary-color-box"
                :class="{ 'active': activeColor === idx }"
              >
                <div class="active-check">
                  <img
                    v-show="activeColor === idx"
                    src="../../../../../static/img/enterprise/branding-check-light.svg"
                    class="active-check-logo"
                    alt="check"
                  />
                </div>
              </div>
            </div>
            <div @click="showColorPicker">
              <img
                src="../../../../../static/img/enterprise/branding-add-new-icon.svg"
                class="branding-add-new-color-icon"
                alt="add-new-icon"
              />
            </div>
            <div v-if="showColor" class="row mb-4">
              <cvt-dialog
                bg-color="#ffffff"
                :show="showColor"
                size="sm"
                :height-auto="true"
                :show-close="true"
                @close="showColorPicker"
              >
                <div class="row no-gutters">
                  <div class="col-auto">
                    <color-picker
                      ref="picker"
                      @color-changed="updateCurrentColor"
                    />
                  </div>
                </div>
                <cvt-button
                  color="success"
                  text="Done"
                  @click.stop="onSelectNewColor"
                />
              </cvt-dialog>
            </div>
          </div>
        </div>

        <!-- Font Section -->
        <div class="primary-font-container">
          <p>Primary Font</p>
          <div class="primary-font-group">
            <div
              v-for="(font, idx) in brand.fonts"
              :key="idx"
              class="primary-font-box-container"
              @click="onSelectFont(idx)"
            >
              <div
                class="primary-font-box"
                :class="{ 'active': activeFont === idx }"
              >
                <p>{{font.name}}</p>
                <div class="active-check">
                  <img
                    v-if="activeFont === idx"
                    src="../../../../../static/img/enterprise/branding-check-light.svg"
                    class="active-check-logo"
                    alt="check"
                  />
                </div>
              </div>
            </div>
            <div class="branding-add-new-container" @click="onShowFont">
              <img
                src="../../../../../static/img/enterprise/branding-add-new-icon.svg"
                class="branding-add-new-icon"
                alt="add-new-icon"
              />
            </div>
            <cvt-dialog
              bg-color="#ffffff"
              :show="showFont"
              size="sm"
              :height-auto="true"
              :show-close="true"
              @close="onShowFont"
            >
              <div v-if="showFont" class="pb-5">
                <font-selector
                  placeholder="Select a font"
                  @input="updateFontFamily($event)"
                />
              </div>
              <cvt-button
                color="success"
                text="Done"
                @click.stop="onSelectNewFont"
              />
            </cvt-dialog>
          </div>
        </div>

        <!-- Button Section -->
        <div class="branding-next-btn-wrap">
          <button
            class="branding-next-btn"
            :disabled="loading"
            @click="onCompleteBrandConfig"
          >
            NEXT : EDITOR TOUR
          </button>
        </div>
      </div>
    </div>

    <org-footer></org-footer>
  </div>
</div>
